export const getBreakpointValue = (breakpoint) => {
  const breakpointValue = getComputedStyle(document.body).getPropertyValue(
    `--breakpoint-${breakpoint}`
  )
  return breakpointValue ? Number(breakpointValue.replace('px', '')) : undefined
}

/**
 * Smooth scroll
 */

export function smoothScroll(target, duration) {
  var target = document.querySelector(target)
  var adminBarHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      '--admin-bar-height'
    ) ?? 0
  )
  var targetPosition = target.offsetTop - (104 - adminBarHeight)
  var startPosition = window.pageYOffset || window.scrollY
  var distance = targetPosition - startPosition
  var startTime = null

  function loop(currentTime) {
    if (startTime === null) startTime = currentTime
    var timeElapsed = currentTime - startTime
    var run = ease(timeElapsed, startPosition, distance, duration)
    window.scrollTo(0, run)
    if (timeElapsed < duration) requestAnimationFrame(loop)
  }

  function ease(t, b, c, d) {
    t /= d / 2
    if (t < 1) return (c / 2) * t * t + b
    t--
    return (-c / 2) * (t * (t - 2) - 1) + b
  }
  requestAnimationFrame(loop)
}
